import { useState, useEffect, useContext } from 'react';
import ApiConstants from '../utils/ApiConstants';
import { LanguageContext } from "../context/LanguageProvider";
import { useLoading } from '../components/LoadingComponent';
import useNavigateToQuestion from '../hooks/useNavigateToQuestion';
import { useAuthenticatedApiFetch } from '../hooks/useAuthenticatedApiFetch';
import { useMsal } from "@azure/msal-react";
import { formatYearMonthAsUTC } from '../utils/utils';

const AISSummary = ({
  client,
  product,
  setFirstLevelArea,
  setSubArea,
  setSecondLevelArea,
  setHasNext,
  setHasPrevious,
  setPreviousFirstLevelArea,
  setPreviousSecondLevelArea,
  setPreviousSubArea,

}) => {

  const navigateToQuestion = useNavigateToQuestion();

  const [apiError, setApiError] = useState(false);
  const [aisSummary, setAisSummary] = useState([]);
  const { t, language } = useContext(LanguageContext);
  const { addRequest, removeRequest } = useLoading();

  const { instance } = useMsal();
  const authenticatedApiFetch = useAuthenticatedApiFetch(instance);

  const handleModifyClick = async (questionCode, compositionType) => {
    await navigateToQuestion(
      product,
      client,      
      compositionType,
      questionCode,
      setFirstLevelArea,
      setSubArea,
      setSecondLevelArea,
      setHasNext,
      setHasPrevious,
      setPreviousFirstLevelArea,
      setPreviousSecondLevelArea,
      setPreviousSubArea,
    );
  };

  useEffect(() => {
    const fetchPersonsaisSummary = async () => {
      addRequest();
      try {

        await instance.initialize();

        const endpoint = ApiConstants.getAISSummary(product, client);
        const url = `${ApiConstants.BASE_URL}${endpoint}`;
        const result = await authenticatedApiFetch(url);

        if (result.status === 200) {
          setAisSummary(result.data.summaryGroupLevel1DtoList);
          setApiError(false);
        } else {
          console.error("Failed to fetch AIS summary, status code:", result.status);
          setApiError(true);
        }
      } catch (error) {
        console.error("Error fetching persons's aisSummary:", error);
        setApiError(true);
      } finally {
        removeRequest();
      }
    };

    fetchPersonsaisSummary();
  }, [client, product, addRequest, removeRequest]);

  if (apiError) {
    return <div className='error text-center'>Failed to load AIS summary. Please try again later.</div>;
  }

  return (
    <>
      {aisSummary.map((level1Group, index) => (
        <div key={index} className='ais-summary-level1'>

          {level1Group.text && <div className="title">{level1Group.text}</div>}

          {level1Group.summaryGroupLevel2DtoList.map((level2Group, index2) => (

            <div key={index2} className={`${level2Group.subAreaUiRenderType} ais-summary-level2`}>
              {level2Group.text && <div className="title">{level2Group.text}</div>}

              {level2Group.summaryCompositionDtoList.map((item, index3) => (
                <div key={index3} id={`${item.id}-${index3}`} className='ais-summary-item'>

                  <div className='ais-summary-text' dangerouslySetInnerHTML={{ __html: item.text }}></div>

                  <div className='ais-summary-container'>


                    <div className='ais-summary-modify'><a href="#"

                      onClick={(e) => {
                        e.preventDefault();
                        handleModifyClick(item.code, item.compositionType);
                      }

                      }
                    >{t('modify')}
                    </a>
                    </div>

                    <div className='ais-summary-answer'>
                      {item.uiFormat === "YEAR-MONTH-UNKNOWN" ? (
                        new Date(item.value).getUTCFullYear() === 1910
                          ? t('unknown')
                          : formatYearMonthAsUTC(item.value, language)
                      ) : (
                        <span dangerouslySetInnerHTML={{ __html: item.value }} />
                      )}

                    </div>



                  </div>

                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default AISSummary;
